import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Container, Row, Col } from 'reactstrap';
import logoFooter from '../../assets/img/logoDarsur-footer.png'
import logo from '../../assets/img/brand/LogoWeb.png';
import logoParadigma from '../../assets/img/logoParadigmaPie.png';

const propTypes = {
  children: PropTypes.node,
};



const defaultProps = {};

class DefaultFooter extends Component {
  render() {

    // eslint-disable-next-line
    const { children, ...attributes } = this.props;

    return (
      <footer>
        <Container>
          <Row className="d-block d-sm-none">
            <div className="col-12"><img className="img-fluid" src={logoFooter} alt="Darsur" />
              <p>
              <a href="#/empresa" alt="LA EMPRESA">LA EMPRESA</a> |
              <a href="#/novedades" alt="NOVEDADES"> NOVEDADES</a> |
              <a href="#/contacto" alt="CONTACTO"> CONTACTO</a>
              </p>
            </div>
          </Row>
          <Row className="py-5">
            <div className="col-sm-3 d-none d-sm-block">
              <img className="img-fluid" src={logoFooter} alt="Darsur" />
            </div>
            <div className="col-sm-3 d-none d-sm-block">
              <ul className="list-unstyled text-left">
                <li><a href="#/empresa" alt="Información sobre Darsur">Información sobre Darsur</a></li>
                <li><a href="#/novedades" alt="Novedades">Novedades</a></li>
                <li><a href="#/contacto" alt="Contacto">Contacto</a></li>
                <li> <a href="#" alt="Mapa del Sitio">Mapa del Sitio</a></li>
              </ul>
            </div>
            <div className="col-sm-2 d-none d-sm-block"></div>

            <div className="col-12 col-sm-4 text-sm-left">
              <p>Suscribase y reciba información sobre nuevos productos y servicios.</p>
              <form className="newsletter">
                <div className="form-group">
                  <input className="form-control" id="nombre" type="email" placeholder="Su dirección de correo" />
                  <button className="btn btn-primary" type="submit">&gt; </button>
                </div>
              </form>
            </div>
          </Row>
        </Container>

        <section className="pie">
          <div className="container mb-3">
            <div className="row">
              <div className="col-12">
                <p>DARSUR {(new Date()).getFullYear()} © Todos los Derechos Reservados.</p>
                <p className="">Desarrollado por <a href="http://www.paradigma.com.ar" className="rounded img-paradigma-footer"><img height={25} src={logoParadigma}/></a> </p>
              </div>
            </div>
          </div>
        </section>
      </footer>

    );
  }
}

DefaultFooter.propTypes = propTypes;
DefaultFooter.defaultProps = defaultProps;

export default DefaultFooter;



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/DefaultFooter.js